import { AgGridReact, AgGridReactProps } from 'ag-grid-react';
import { agForesightTheme } from '../../theme/ag-foresight';
import { GridWrapper } from './AgTable';
import { useGridTrackingHandlers } from './agTableTracking';
import { GridLoadingOverlay } from './GridLoadingOverlay';
import { useCloseContextMenuOnBodyScroll } from './useCloseContextMenuOnBodyScroll';

export function AgTableWithBaseStyle(props: AgGridReactProps) {
  const { onGridReady, onFilterChanged } = useGridTrackingHandlers(props);
  const { onBodyScroll, onContextMenuVisibleChanged } = useCloseContextMenuOnBodyScroll(props);

  return (
    <div css={GridWrapper}>
      <AgGridReact
        {...props}
        theme={props.theme ?? agForesightTheme}
        loadingOverlayComponent={props.loadingOverlayComponent ?? GridLoadingOverlay}
        onBodyScroll={onBodyScroll}
        onContextMenuVisibleChanged={onContextMenuVisibleChanged}
        onFilterChanged={onFilterChanged}
        onGridReady={onGridReady}
      />
    </div>
  );
}
